import { render, staticRenderFns } from "./CurrencySwitcher.vue?vue&type=template&id=b20ed008&lang=pug"
import script from "./CurrencySwitcher.vue?vue&type=script&lang=js"
export * from "./CurrencySwitcher.vue?vue&type=script&lang=js"
import style0 from "./CurrencySwitcher.vue?vue&type=style&index=0&id=b20ed008&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports